// Module
var code = "<ui-view></ui-view> <div class=\"liste-footer\"> <div class=\"liste-footer-2\"> <div class=\"mas-row mas-jc-fend\"> <div class=\"mas-col-fit\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.save()\"> <span class=\"glyphicon glyphicon-floppy-disk\"></span> <span translate=\"VALIDER\"></span> </button> </div> </div> </div> </div> ";
// Exports
module.exports = code;